// @ts-check

/**
 * @template {object} T
 * @param {T} o
 * @returns {import('./types').Entries<T>}
 */
export function objectEntries(o) {
  return /** @type {import('./types').Entries<T>} */ (Object.entries(o));
}
